// extracted by mini-css-extract-plugin
export default {"linkButtonWrapper":"spinner_linkButtonWrapper__pxeIl","linkButton":"spinner_linkButton__0rwoe","ldsRing":"spinner_ldsRing__CQd7B","lds-ring":"spinner_lds-ring__amaoJ"};